// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oAHk","icon":"styles_icon__1jMV2"};